import React, { useState, useRef, useEffect } from 'react';
import { BsPeople } from "react-icons/bs";
import { GrClose } from "react-icons/gr";

import "./SearchBarStyle.css";

const PassengerSelect = ({
    adultsCount,
    setAdultsCount,
    childrenCount,
    setChildrenCount
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            // If the dropdown is open and the click is outside the dropdown ref
            if (isOpen && dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const toggleDropdown = () => setIsOpen(!isOpen);

    const totalPassengers = adultsCount + childrenCount;

    return (
        <div className="search-field-wrapper" ref={dropdownRef}>
            <BsPeople className="search-icon" />
            <div className="custom-select-container">
                <div
                    className="custom-select-trigger"
                    onClick={toggleDropdown}
                >
                    {totalPassengers === 0 ? (
                        <span className="placeholder-text">Passengers</span>
                    ) : (
                        <span className="selected-text">
                            {adultsCount > 0 ? `${adultsCount} Adult${adultsCount > 1 ? 's' : ''}` : ''}
                            {adultsCount > 0 && childrenCount > 0 ? ', ' : ''}
                            {childrenCount > 0 ? `${childrenCount} Minor${childrenCount > 1 ? 's' : ''}` : ''}
                        </span>
                    )}
                </div>

                {isOpen && (
                    <div className="custom-dropdown-menu passengers-dropdown">
                        <div className="custom-dropdown-header">
                            <span className="dropdown-label">Passengers</span>
                            <GrClose
                                className="close-icon"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setIsOpen(false);
                                }}
                            />
                        </div>

                        <div className="custom-dropdown-content">
                            {/* Adults Calculator */}
                            <div className="passenger-row">
                                <div>
                                    <div className="passenger-label">Adults</div>
                                    <div className="passenger-sublabel">18+</div>
                                </div>
                                <div className="counter-controls">
                                    <button
                                        className="counter-btn"
                                        onClick={() => setAdultsCount(Math.max(0, adultsCount - 1))}
                                        disabled={adultsCount === 0}
                                        type="button"
                                    >
                                        -
                                    </button>
                                    <span className="counter-value">{adultsCount}</span>
                                    <button
                                        className="counter-btn"
                                        onClick={() => setAdultsCount(adultsCount + 1)}
                                        type="button"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>

                            {/* Children Calculator */}
                            <div className="passenger-row">
                                <div>
                                    <div className="passenger-label">Minors</div>
                                    <div className="passenger-sublabel">0-17</div>
                                </div>
                                <div className="counter-controls">
                                    <button
                                        className="counter-btn"
                                        onClick={() => setChildrenCount(Math.max(0, childrenCount - 1))}
                                        disabled={childrenCount === 0}
                                        type="button"
                                    >
                                        -
                                    </button>
                                    <span className="counter-value">{childrenCount}</span>
                                    <button
                                        className="counter-btn"
                                        onClick={() => setChildrenCount(childrenCount + 1)}
                                        type="button"
                                    >
                                        +
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PassengerSelect;
